import { useQueryParams } from '@calendly/hooks';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'components/organizations/layout';
import { useGetUserConsolidationsQuery } from './api';
import { OrgConsolidationCompletePopup } from './migration_complete_popup';
import { OwnerTransferPopup } from './owner_transfer_popup';
import { roleSelector } from '../../selectors/current_user';
const notificationBannerCss = "nk1ypj7";
const NotificationBanner = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(notificationBannerCss, props.className)} />;
});
const notificationContainerCss = "n2h4bsr";
const NotificationContainer = forwardRef((props, ref) => <Container ref={ref} {...props} className={classNames(notificationContainerCss, props.className)} />);
const notificationMessageCss = "n1lpahrz";
const NotificationMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(notificationMessageCss, props.className)} />;
});
export const OrgConsolidationGlobalNotification = () => {
  const {
    data
  } = useGetUserConsolidationsQuery();
  const role = useSelector(roleSelector);
  const query = useQueryParams();
  const transferOwnership = Boolean(query?.transfer_ownership);
  const confirmMigrationToken = query?.confirm_migration_token;
  if (!data) {
    return null;
  }
  const {
    showToBeConsolidatedBanner,
    showConsolidationCompletePopup,
    pendingConsolidations
  } = data;
  const renderUserConsolidatingBanner = () => <NotificationBanner>
      <NotificationContainer>
        <NotificationMessage>
          <div>{HtmlParser(I18n.t('publisher.organization.consolidation.marked_for_consolidation'))}</div>
        </NotificationMessage>
      </NotificationContainer>
    </NotificationBanner>;
  return <>
      {showToBeConsolidatedBanner && renderUserConsolidatingBanner()}
      {showConsolidationCompletePopup && <OrgConsolidationCompletePopup />}
      {pendingConsolidations.length > 0 && transferOwnership && role === 'owner' && <OwnerTransferPopup confirmMigrationToken={confirmMigrationToken} />}
    </>;
};

require("./global_notification.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./global_notification.js");